/**
 * What the extensions add to the Data Manager. The platform resolves
 * `@afriannotate/dm-extensions` to this file when AFRI_EXTENSIONS_DIR points
 * at the package beside it, and to an empty stub otherwise.
 */
import { CollectionBar } from "./collection/CollectionBar";
import { ContributorCell, PhotoStackCell } from "./collection/RecordCells";
import { RecordGrid } from "./collection/RecordGrid";

type Project = { extensions?: { collection?: { mode?: string } } };

/** Open collection: a prompt stays open and every Submit saves one more
 *  record on it. The table lists records; the toolbar opens the prompts. */
const openCollection = {
  id: "open-collection",
  listsAnnotations: true,
  repeat: true,
  // The contributor's counts on a prompt (see `endpoints` below).
  stateEndpoint: "taskCollection",
  words: {
    labelButton: "Collect",
    saved: (n?: number) => (n ? `Record ${n} saved. Ready for the next one.` : "Record saved. Ready for the next one."),
    notSaved: "The record is not saved",
    updated: "Record updated",
    notUpdated: "The record is not updated",
    deleted: "Record deleted",
    notDeleted: "The record could not be deleted",
  },
  footer: ({ rows, tasks }: { rows: number; tasks: number }) => [
    { label: "Records", title: "Records in this view", value: rows },
    { label: "Prompts", title: "Prompts in the project", value: tasks },
  ],
  toolbar: [{ id: "prompts-button", label: "Prompts", event: "promptsClicked" }],
  Grid: RecordGrid,
  LabelPanel: CollectionBar,
};

export const modes = [(project: Project) => (project?.extensions?.collection?.mode === "open" ? openCollection : null)];

// Records table: matched by the column names "photo" and "contributor".
export const cells = { Photo: PhotoStackCell, Contributor: ContributorCell };

export const endpoints = {
  // The contributor's counts and records on a prompt.
  taskCollection: "/../tasks/:taskID/collection/",
  // Record rows (one per annotation) for tabs that target annotations.
  annotations: "/records",
};
